module.exports = {
      id: "person-with-border-usage",
      viewBox: "0 0 19 22",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#person-with-border",
      toString: function () {
        return this.url;
      }
    }